module.exports = __webpack_public_path__ + "img/pic_guzhi.bb8d29fc.png";